module.exports = __webpack_public_path__ + "static/img/cover9.d4c5feaf.jpg";